import type { WhitelabelVariantDefinition } from '../../types';

const coralPrimary = {
  900: '#7A1F0F',
  800: '#A82B17',
  700: '#DD3D1F',
  500: '#FF6B47',
  300: '#FFA48A',
  100: '#FFE6DD',
  contrastText: '#FFFFFF',
} as const;

export const leadzaiCoralTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: coralPrimary[900],
      dark: coralPrimary[800],
      main: coralPrimary[700],
      light: coralPrimary[500],
      lighter: coralPrimary[300],
      muted: coralPrimary[100],
      contrastText: coralPrimary.contrastText,
    },
  },
  typography: { fontFamily: 'DM Sans' },
};
